import { createItem } from 'bones/design-system/utils/select/createItem';
import { SelectItem } from 'bones/design-system/utils/select/types';

export const DIVIDER_VALUE = '__divider__';

export const createDivider = <T extends SelectItem | null = null>(text = '') =>
  createItem<T>(text, DIVIDER_VALUE);
